import { catchError, ObservableInput } from 'rxjs';
import { UnknownServerOrConnectionError } from '../unknown-server-or-connectrion-error.model';

export function catchResponseError<T = unknown>(callback: (error: T) => ObservableInput<any>) {
  return catchError((err) => {
    if (err instanceof UnknownServerOrConnectionError) {
      throw err;
    }

    return callback(err);
  });
}
